// Recolecta módulos distintos desde entidades.
export function collectEntityModules(entities: any[]) {
    const found = new Map();
    for (const entity of entities) addEntityModules(entity, found);
    return found;
}

// Agrega los módulos de una entidad.
export function addEntityModules(entity: any, found: Map<string, any>) {
    for (const link of (entity.entityModules || [])) addModuleLink(link, found);
}

// Agrega un vínculo entidad-módulo.
export function addModuleLink(link: any, found: Map<string, any>) {
    if (link.moduleId && link.module) setMissing(found, link.moduleId, link.module);
}

// Inserta la entrada cuando falta.
export function setMissing(found: Map<string, any>, id: string, module: any) {
    if (found.has(id)) return;
    found.set(id, module);
}

// Fusiona módulos activos faltantes.
export function mergeActiveModules(found: Map<string, any>, actives: any[]) {
    for (const active of actives) setMissing(found, active.id, toModuleColumn(active));
}

// Moldea un módulo activo como columna.
export function toModuleColumn(active: any) {
    return { id: active.id, acronym: active.acronym, name: active.name };
}

// Ordena columnas por acrónimo.
export function sortModuleColumns(columns: any[]) {
    return [...columns].sort(byAcronym);
}

// Compara columnas por acrónimo.
export function byAcronym(left: any, right: any) {
    return left.acronym.localeCompare(right.acronym);
}

// Busca el vínculo de una entidad para un módulo.
export function findModuleLink(entity: any, moduleId: string) {
    for (const link of (entity.entityModules || [])) {
        if (link.moduleId === moduleId) return link;
    }
    return null;
}

// Lee el nombre del auditor con reemplazo.
export function auditorDisplayName(link: any) {
    if (link) return fallbackName(link.auditor);
    return '—';
}

// Lee el nombre del auditor con reemplazo.
export function fallbackName(auditor: any) {
    if (auditor) return auditor.displayName || '—';
    return '—';
}
